/*=========================================================================================
  File Name: moduleFlipBankAccounts.js
  Description: FlipBankAccounts Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleFlipBankAccountsState.js'
import mutations from './moduleFlipBankAccountsMutations.js'
import actions from './moduleFlipBankAccountsActions.js'
import getters from './moduleFlipBankAccountsGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
